import { render, staticRenderFns } from "./layoutAppMain.vue?vue&type=template&id=201b222c&scoped=true&"
import script from "./layoutAppMain.vue?vue&type=script&lang=js&"
export * from "./layoutAppMain.vue?vue&type=script&lang=js&"
import style0 from "./layoutAppMain.vue?vue&type=style&index=0&id=201b222c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201b222c",
  null
  
)

export default component.exports